import { render } from "./assigning_permissions.html?vue&type=template&id=4d2d18e0&external"
import script from "./assigning_permissions.js?vue&type=script&lang=js&external"
export * from "./assigning_permissions.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__